import { Chip, Skeleton, Stack, SvgIcon, Typography } from '@mui/material'
import { ModelListRowModel } from '../../types'
import { ItemTile } from '~/ui/components/ItemTile'
import { IconSeparator, IconArrowRight } from '@tabler/icons-react'
import { format } from 'date-fns'
import { useGetActions } from '../../hooks/useGetActions'
import { EmptyStateRadar } from '~/ui/components/EmptyState/EmptyStateRadar'

export const ActionsHistory = ({ data }: { data: ModelListRowModel }) => {
  const { data: actions, isLoading } = useGetActions(data.stock_code)

  if (isLoading) {
    return (
      <Stack spacing={1} useFlexGap>
        {[1, 2, 3].map((el) => (
          <ItemTile key={el} Icon={IconArrowRight}>
            <Stack>
              <Skeleton variant="text" width={100} height={35} />
              <Stack direction="row" spacing={0.5} useFlexGap>
                <Skeleton variant="text" width={100} height={20} />
                <Skeleton variant="text" width={100} height={20} />
              </Stack>
            </Stack>
          </ItemTile>
        ))}
      </Stack>
    )
  }

  if (!actions || actions.length === 0) {
    return (
      <EmptyStateRadar
        title="No actions found"
        description="There are no actions for this model"
        featureIconSize="small"
      />
    )
  }

  return (
    <Stack spacing={1} useFlexGap sx={{ overflow: 'auto', height: 1 }}>
      {actions.map((action) => {
        const actionChange = action.new_value - action.old_value
        return (
          <ItemTile key={action.id} Icon={IconArrowRight}>
            <Stack
              direction="row"
              sx={{ alignItems: 'center', justifyContent: 'space-between', flexGrow: 1 }}
            >
              <Stack
                direction="row"
                spacing={0.5}
                useFlexGap
                divider={
                  <SvgIcon fontSize="small" sx={{ color: 'text.secondary' }}>
                    <IconSeparator />
                  </SvgIcon>
                }
              >
                <Typography variant="body2" color="text.secondary">
                  {format(action.created_at, 'dd/MM/yyyy')}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ span: { fontWeight: 'bold' } }}
                >
                  {action.old_value} → <span>{action.new_value}</span> CZK
                </Typography>
              </Stack>
              <Chip
                color={actionChange > 0 ? 'success' : actionChange < 0 ? 'warning' : 'default'}
                label={`${actionChange} CZK`}
                size="small"
              />
            </Stack>
          </ItemTile>
        )
      })}
    </Stack>
  )
}
